"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBody = exports.StyledHeader = exports.StyledContent = exports.StyledDialogActions = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.StyledDialogActions = (0, flora_react_1.styled)(flora_react_1.Flex, {
    width: '100%',
    gap: '$4',
    padding: '$2',
    justifyContent: 'space-between',
});
exports.StyledContent = (0, flora_react_1.styled)(flora_react_1.ModalContent, {
    width: '100%',
    justifyItems: 'center',
});
exports.StyledHeader = (0, flora_react_1.styled)(flora_react_1.ModalHeader, {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
});
exports.StyledBody = (0, flora_react_1.styled)(flora_react_1.ModalBody, {
    borderTop: '1px solid #F5F1EB',
    borderBottom: '1px solid #F5F1EB',
});
